export default class CategoryModel {
  _id = "";
  name = "";
  posts = [];
}
